import { ImageSourcePropType } from 'react-native';
import { GameNames } from '../store/slices/GameTypes';
import { setAnimations, setImage, TimageINTExtend } from '../store/slices/gameObjectSlice';
import { store } from '../store/store';
import { TimageINT, TanimationsINT } from './../store/slices/gameObjectSlice';
import { Action } from './Actions/Action';
import { parseRequire } from '../utils/parseImageUrl';
import { setSeenImage } from '../store/slices/AdvanceSlice';

export interface ImageObject {
    [key: string]: TimageINT & { key?: string; };
}
export interface ImageOptions {
    transition?: boolean,
    shake?: boolean,
    putParent?: boolean;
    duration?: number,
    wait?: number | boolean,
    looping?: number,
    autoAdd?: Function,
    hideText?: boolean;
    effect?: boolean,

}
export interface VideoOptions extends ImageOptions {
    loop?: number | [number, number],
    waitForEnd?: boolean;
    speed?: number;

}

export function asImages<T extends ImageObject>(arg: T, father?: TimageINT): { [Key in keyof T]: Omit<T[Key], "url"> & { key: string, url: ImageSourcePropType; } } {
    if (typeof arg === "object") {
        Object.keys(arg).forEach(key => {
            const newUrl = parseRequire(arg[key].url);
            const newKey = father ? `${father.key}_${key}` : key;
            arg[key].key = newKey;
            arg[key].url = newUrl;
            if (arg[key].poster) {
                arg[key].poster!.url = parseRequire(arg[key].poster?.url);
                arg[key].poster!.key = newKey;
            }

            for (let insideKey in arg[key]) {
                if (insideKey !== "url") {
                    if (insideKey === "partials") {
                        if (arg[key].partials) {
                            asImages(arg[key].partials as ImageObject, arg[key]);

                        }
                    }
                }
            }

            if (father) {
                // const url = parseImage(partials[partial]?.url);
                if (newKey === "V9AnnMCMotel_283_V9AnnMCMotel_283_m") {
                    // debugger;
                }

                const { partials: mainImagePartials, ...imageProps } = father;

                const partialParsed: TimageINT = {
                    ...imageProps,
                    ...arg[key],
                    options: { ...arg[key].options },
                    parent: father,
                    url: newUrl,
                    key: newKey,

                    main: parseRequire((father.url) || father.main),
                    partial: true
                };

                ImageClass._globalImages.set(newKey, partialParsed);
            } else {

                if (ImageClass._globalImages.has(newKey)) {
                    throw new Error(`Image ${newKey}, as already been added. url: ${newUrl}`);
                }
                ImageClass._globalImages.set(newKey, { ...arg[key], url: newUrl, key: newKey });
            }

        });
    }
    return arg as { [Key in keyof T]: T[Key] & { key: string; } };
}

export default class ImageClass {
    public static _globalImages: Map<string | undefined, TimageINT> = new Map();
    public static index = 0;
    constructor() { }


    static setImage(image: Partial<TimageINT>, options?: ImageOptions): any {

        const storedImage = ImageClass._globalImages.get(image?.key) as TimageINT;
        const data: TimageINT = { ...storedImage, ...image, options: options || storedImage?.options, type: GameNames.IMAGE };
        return new Action(data, GameNames.IMAGE).run(
            function image(callback: () => void) {
                store.dispatch(setImage(data));
                callback();
            }
        );
    }
    static setAnimation(_animation: Partial<TimageINT> & { poster: Partial<TimageINT>; }, options?: VideoOptions): any {
        const storedImage = ImageClass._globalImages.get(_animation?.key) as TimageINT;
        const data: TimageINT = { ...storedImage, ..._animation, options: options || storedImage?.options, type: GameNames.ANIMATION };
        return new Action(data, GameNames.ANIMATION).run(
            function animation(callback: () => void) {
                store.dispatch(setAnimations({ sources: [data], key: _animation.key as string, options, type: GameNames.ANIMATION }));
                callback();
            }
        );
    }
    static setAnimations(animations: Partial<TimageINT & { poster: any; }>[], options?: VideoOptions): any {
        // const storeAnimations = animations.map(anim => ImageClass._globalImages.get(anim?.key));
        const storeAnimations = animations.map(anim => ({ ...ImageClass._globalImages.get(anim?.key), ...anim, options: anim.options || ImageClass._globalImages.get(anim?.key)?.options, type: GameNames.ANIMATION }));
        // const storedImage = ImageClass._globalImages.get(animation?.key) as TimageINT;
        const data: TanimationsINT = { sources: storeAnimations as TimageINT[], key: animations.map(anim => anim.key).join("_"), options, type: GameNames.ANIMATION };
        return new Action(data, GameNames.ANIMATION).run(
            function animation(callback: () => void) {
                store.dispatch(setAnimations(data));
                callback();
            }
        );
    }


}